// API Endpoints
export const companyId = "7Dw6sBMQrHLSiHoirHdN";

export const API_ENDPOINTS = {
  EMAIL_SENDER: "https://fuego-elegho-emailsender.vercel.app/api/subscribe",
  GENERAL_EMAIL: "https://fuego-elegho-emailsender.vercel.app/api/general",
};

export const adminEmailAddress = "admin@fuego.com";
export const adminEmailName = "Fuego Admin";
export const appName = "Fuego App";
export const domainName = "fuego.com";
export const appURL = "https://fuego.elegho.app";
export const companyName = "Peninsula De Punta Fuego";

export const unitNumberLabel = "Lot Number";
export const unitOwnerLabel = "Lot Owner";
export const residentLabel = "Resident";
export const unitLabel = "Lot";

export const phaseLabel = "Phase";
export const blockLabel = "Block";
export const lotLabel = "Lot";
export const hoaLabel = "HOA";
export const versionNumber = "1.90.02";

export const unsplashBackground =
  " https://images.unsplash.com/photo-1688680976459-3722d88ec775?q=80&w=3870&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
